/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import { payloadUrlName } from '../components/GalleryImageUpload';
import {
    SUBCATEGORIES_ENTITY,
    USERS_ENTITY,
    DEFECT_TYPES_ENTITY,
    COMPLAINTS_ENTITY,
    MANAGER_TECHNICIAN_ENTITY,
    ASSETS_ENTITY,
    LOCATIONS_ENTITY,
    CATEGORIES_ENTITY,
    CONTACT_INFO,
    APPLICATION_FORM_PACKAGE_PLANS,
    APPLICATION_FORM_QUESTIONS,
    APPLICATION_FORM_SERVICES,
    APPLICATION_FORM_PACKAGES,
    SERVICE_PROCESS_STEPS,
    SERVICE_PROCESS_DETAILS,
    SERVICE_PROCESS_SUBTITLE,
    MODELS_ENTITY,
    CATEGORY_SUBCATEGORIES_ENTITY,
    COUPONS_ENTITY,
    CATEGORY_CATEGORIES_ENTITY,
    MAKES_ENTITY,
    THIRD_PARTY_CHARGES_ENTITY,
    TOWING_CHARGES_ENTITY,
    GARAGE_COMMISSION_TYPE,
    COMMISSION_LIST_ENTITY,
    FEATURED_COLLECTION,
    CURATED_SPACES,
    CUSTOMIZABLE_PRODUCTS,
    MOODBOARD_SECTIONS,
    COLLABORATION_SECTIONS,
    CATEGORY,
    COLLABS,
    JOB_POSTING,
    PRODUCTS,
    STORIES,
    PRODUCT_CATEGORIES,
    CATALOGUE,
    ABOUT,
    SPACES,
    USERS,
    CONTACT,
    HERO_IMAGE,
    HEADER_INFO,
} from '../constants/EntityName';

// It is hard-coded data and needs to be updated whenever the id of Categories change on backend
export const categoryIds: { [key: string]: string } = {
    fresh: '1',
    kitchen: '2',
};

export const getOutgoingPayload = (
    entityName: string,
    rawPayload: any,
    additionalData: any,
    extraPayloadData?: any,
    incomingFormData?: any,
    nestedEntityName?: string,
    isCreateMode?: boolean,
) => {
    switch (entityName) {
        case FEATURED_COLLECTION:
        case CURATED_SPACES:
        case CUSTOMIZABLE_PRODUCTS: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                const payloadUrlName: any = {
                    1: 'desktopPngUrl',
                    2: 'desktopWebPUrl',
                    3: 'mobilePngUrl',
                    4: 'mobileWebPUrl',
                };
                if (key === 'images') {
                    acc['images'] = value.map((item: any, i: number) => {
                        const obj: any = {};
                        if (item['input' + i]) {
                            obj['imageInfo'] = item['input' + i];
                        }
                        [1, 2, 3, 4].forEach((num: any) => {
                            obj[payloadUrlName[num]] = item['image' + num][0]['response']['data'];
                        });
                        return obj;
                    });
                    return acc;
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case MOODBOARD_SECTIONS: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (
                    key === 'desktopPngUrl' ||
                    key === 'desktopWebPUrl' ||
                    key === 'mobilePngUrl' ||
                    key === 'mobileWebPUrl'
                ) {
                    if (!acc?.images) {
                        acc['images'] = [
                            {
                                [key]: value,
                            },
                        ];
                    } else {
                        acc.images[0][key] = value;
                    }
                    return acc;
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case COLLABORATION_SECTIONS: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (
                    key === 'desktopPngUrl' ||
                    key === 'desktopWebPUrl' ||
                    key === 'mobilePngUrl' ||
                    key === 'mobileWebPUrl'
                ) {
                    if (!acc?.images) {
                        acc['images'] = [
                            {
                                [key]: value,
                            },
                        ];
                    } else {
                        acc.images[0][key] = value;
                    }
                    return acc;
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case CATEGORY: {
            const {
                name,
                type,
                status,
                images,
                desktopPngUrl,
                isSpatialRenderProductDropdown,
                desktopSpatialPngUrl1,
                desktopSpatialWebPUrl1,
                mobileSpatialPngUrl1,
                mobileSpatialWebPUrl1,
                desktopSpatialPngUrl2,
                desktopSpatialWebPUrl2,
                mobileSpatialPngUrl2,
                mobileSpatialWebPUrl2,
            } = rawPayload;

            let headerImage;

            // Handle both new images field and fallback to individual fields
            if (images && images.length > 0) {
                // Process multiImageUpload format
                headerImage = images.map((item: any, i: number) => {
                    const obj: any = {};
                    if (item['input' + i]) {
                        obj['imageInfo'] = item['input' + i];
                    }
                    const payloadUrlName: any = {
                        1: 'desktopPngUrl',
                        2: 'desktopWebPUrl',
                        3: 'mobilePngUrl',
                        4: 'mobileWebPUrl',
                    };
                    [1, 2, 3, 4].forEach((num: any) => {
                        // Handle both new uploads and existing URLs
                        if (item['image' + num] && item['image' + num][0]) {
                            if (item['image' + num][0]['response']) {
                                // New upload
                                obj[payloadUrlName[num]] = item['image' + num][0]['response']['data'];
                            } else if (item['image' + num][0]['url']) {
                                // Existing URL
                                obj[payloadUrlName[num]] = item['image' + num][0]['url'];
                            }
                        }
                    });
                    return obj;
                });
            } else if (desktopPngUrl && desktopPngUrl.length > 0) {
                // Fallback to single desktopPngUrl field
                const desktopUrl = desktopPngUrl[0]?.response?.data || desktopPngUrl[0]?.url || desktopPngUrl;
                headerImage = [
                    {
                        desktopPngUrl: desktopUrl,
                        desktopWebPUrl: desktopUrl, // Use same URL for WebP as fallback
                        mobilePngUrl: desktopUrl, // Use same URL for mobile as fallback
                        mobileWebPUrl: desktopUrl, // Use same URL for mobile WebP as fallback
                    },
                ];
            } else {
                headerImage = [{}];
            }

            const res = {
                name,
                type,
                status,
                headerImage,
                isSpatialRender: isSpatialRenderProductDropdown,
            };

            if (isSpatialRenderProductDropdown) {
                // Helper function to extract URL from field
                const extractUrl = (field: any) => {
                    if (!field || !field.length) return '';
                    if (field[0]?.response?.data) return field[0].response.data;
                    if (field[0]?.url) return field[0].url;
                    return field;
                };

                Object.assign(res, {
                    spatialRenderImages: [
                        {
                            'urls': [
                                {
                                    'desktopPngUrl': extractUrl(desktopSpatialPngUrl1),
                                    'desktopWebPUrl': extractUrl(desktopSpatialWebPUrl1),
                                    'mobilePngUrl': extractUrl(mobileSpatialPngUrl1),
                                    'mobileWebPUrl': extractUrl(mobileSpatialWebPUrl1),
                                },
                            ],
                        },
                        {
                            'urls': [
                                {
                                    'desktopPngUrl': extractUrl(desktopSpatialPngUrl2),
                                    'desktopWebPUrl': extractUrl(desktopSpatialWebPUrl2),
                                    'mobilePngUrl': extractUrl(mobileSpatialPngUrl2),
                                    'mobileWebPUrl': extractUrl(mobileSpatialWebPUrl2),
                                },
                            ],
                        },
                    ],
                });
            }

            return res;
        }

        case COLLABS: {
            const obj = Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                const payloadUrlName: any = {
                    1: 'desktopPngUrl',
                    2: 'desktopWebPUrl',
                    3: 'mobilePngUrl',
                    4: 'mobileWebPUrl',
                };
                if (key === 'images') {
                    acc['images'] = value.map((item: any, i: number) => {
                        const obj: any = {};
                        if (item['input' + i]) {
                            obj['imageInfo'] = item['input' + i];
                        }
                        [1, 2, 3, 4].forEach((num: any) => {
                            obj[payloadUrlName[num]] = item['image' + num][0]['response']['data'];
                        });
                        return obj;
                    });
                    return acc;
                } else if (key === 'title' || key === 'description') {
                    if (!acc?.content) {
                        acc['content'] = [
                            {
                                [key]: value,
                            },
                        ];
                    } else {
                        acc.content[0][key] = value;
                    }
                } else if (key === 'remarkAuthor' || key === 'remarkDesignation' || key === 'remarkText') {
                    // Map the field names to the remark object structure at root level
                    let remarkKey = 'text';
                    if (key === 'remarkAuthor') {
                        remarkKey = 'author';
                    } else if (key === 'remarkDesignation') {
                        remarkKey = 'designation';
                    }

                    if (!acc['remark']) {
                        acc['remark'] = {};
                    }
                    acc['remark'][remarkKey] = value;
                } else if (
                    key === 'heroDesktopPngUrl' ||
                    key === 'heroDesktopWebPUrl' ||
                    key === 'heroMobilePngUrl' ||
                    key === 'heroMobileWebPUrl' ||
                    key === 'heroImageInfo'
                ) {
                    acc['heroImage'] = {
                        'desktopPngUrl': rawPayload.heroDesktopPngUrl,
                        'desktopWebPUrl': rawPayload.heroDesktopWebPUrl,
                        'mobilePngUrl': rawPayload.heroMobilePngUrl,
                        'mobileWebPUrl': rawPayload.heroMobileWebPUrl,
                        'imageInfo': rawPayload?.heroImageInfo?.length ? rawPayload.heroImageInfo : '',
                    };
                } else if (key === 'featuredProducts') {
                    acc['featuredProducts'] = value.map((id: any) => {
                        if (typeof id === 'string') {
                            return id;
                        } else {
                            return id.value;
                        }
                    });
                    return acc;
                }

                const obj = { ...acc, [key]: value };
                delete obj['desktopPngUrl'];
                delete obj['desktopWebPUrl'];
                delete obj['mobilePngUrl'];
                delete obj['mobileWebPUrl'];
                delete obj['imageInfo'];

                delete obj['remarkAuthor'];
                delete obj['remarkDesignation'];
                delete obj['remarkText'];
                delete obj['title'];
                delete obj['description'];

                delete obj['heroDesktopPngUrl'];
                delete obj['heroDesktopWebPUrl'];
                delete obj['heroMobilePngUrl'];
                delete obj['heroMobileWebPUrl'];
                delete obj['heroImageInfo'];

                if (Array.isArray(value)) {
                    value = value.map((o: any) => {
                        delete o['_id'];
                        return {
                            ...o,
                        };
                    });
                }

                return obj;
            }, {});

            return obj;
        }

        case STORIES: {
            const obj = Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                const payloadUrlName: any = {
                    1: 'desktopPngUrl',
                    2: 'desktopWebPUrl',
                    3: 'mobilePngUrl',
                    4: 'mobileWebPUrl',
                };
                if (key === 'images') {
                    acc['images'] = value.map((item: any, i: number) => {
                        const obj: any = {};
                        if (item['input' + i]) {
                            obj['imageInfo'] = item['input' + i];
                        }
                        [1, 2, 3, 4].forEach((num: any) => {
                            obj[payloadUrlName[num]] = item['image' + num][0]['response']['data'];
                        });
                        return obj;
                    });
                    return acc;
                } else if (key === 'title' || key === 'description') {
                    if (!acc?.content) {
                        acc['content'] = [
                            {
                                [key]: value,
                                'authorDetails': {},
                            },
                        ];
                    } else {
                        acc.content[0][key] = value;
                    }
                } else if (key === 'name' || key === 'designation') {
                    if (acc?.content) {
                        if (!acc.content[0]['authorDetails']) {
                            acc.content[0]['authorDetails'] = {};
                        }
                        acc.content[0]['authorDetails'][key] = value;
                    } else {
                        acc['content'] = [
                            {
                                'authorDetails': {
                                    [key]: value,
                                },
                            },
                        ];
                    }
                } else if (
                    key === 'heroDesktopPngUrl' ||
                    key === 'heroDesktopWebPUrl' ||
                    key === 'heroMobilePngUrl' ||
                    key === 'heroMobileWebPUrl' ||
                    key === 'heroImageInfo'
                ) {
                    acc['heroImage'] = {
                        'desktopPngUrl': rawPayload.heroDesktopPngUrl,
                        'desktopWebPUrl': rawPayload.heroDesktopWebPUrl,
                        'mobilePngUrl': rawPayload.heroMobilePngUrl,
                        'mobileWebPUrl': rawPayload.heroMobileWebPUrl,
                        'imageInfo': rawPayload?.heroImageInfo?.length ? rawPayload.heroImageInfo : '',
                    };
                } else if (key === 'featuredProducts') {
                    acc['featuredProducts'] = value.map((id: any) => {
                        if (typeof id === 'string') {
                            return id;
                        } else {
                            return id.value;
                        }
                    });
                    return acc;
                }

                const obj = { ...acc, [key]: value };
                delete obj['desktopPngUrl'];
                delete obj['desktopWebPUrl'];
                delete obj['mobilePngUrl'];
                delete obj['mobileWebPUrl'];
                delete obj['imageInfo'];

                delete obj['name'];
                delete obj['designation'];
                delete obj['title'];
                delete obj['description'];

                delete obj['heroDesktopPngUrl'];
                delete obj['heroDesktopWebPUrl'];
                delete obj['heroMobilePngUrl'];
                delete obj['heroMobileWebPUrl'];
                delete obj['heroImageInfo'];

                if (Array.isArray(value)) {
                    value = value.map((o: any) => {
                        delete o['_id'];
                        return {
                            ...o,
                        };
                    });
                }

                return obj;
            }, {});

            return obj;
        }

        case PRODUCT_CATEGORIES: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (
                    key === 'desktopPngUrl' ||
                    key === 'desktopWebPUrl' ||
                    key === 'mobilePngUrl' ||
                    key === 'mobileWebPUrl'
                ) {
                    if (!acc?.images) {
                        acc['images'] = [
                            {
                                [key]: value,
                            },
                        ];
                    } else {
                        acc.images[0][key] = value;
                    }
                    return acc;
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case JOB_POSTING: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (
                    key === 'description' ||
                    key === 'responsibilities' ||
                    key === 'requirements' ||
                    key === 'benefits'
                ) {
                    acc[key] = [value].flat(1);
                    return acc;
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case PRODUCTS: {
            const updatedPayload = Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                const payloadUrlName: any = {
                    1: 'desktopPngUrl',
                    2: 'desktopWebPUrl',
                    3: 'mobilePngUrl',
                    4: 'mobileWebPUrl',
                };

                if (key === 'images') {
                    acc['images'] = value.map((item: any, i: number) => {
                        const obj: any = {};
                        if (item['input' + i]) {
                            obj['imageInfo'] = item['input' + i];
                        }
                        [1, 2, 3, 4].forEach((num: any) => {
                            obj[payloadUrlName[num]] = item['image' + num][0]['response']['data'];
                        });
                        return obj;
                    });
                    return acc;
                }

                if (key === 'specialImages') {
                    acc['spatialRenderImages'] = value.map((item: any, i: number) => ({
                        urls: [
                            {
                                desktopPngUrl: item['image1'][0]['response']['data'],
                                desktopWebPUrl: item['image2'][0]['response']['data'],
                                mobilePngUrl: item['image3'][0]['response']['data'],
                                mobileWebPUrl: item['image4'][0]['response']['data'],
                            },
                        ],
                        meta: {
                            dimensions: item.dropdown0,
                        },
                    }));
                    return acc;
                }

                if (key === 'isSpatialRender' && !acc['isSpatialRender']) {
                    acc['spatialRenderImages'] = [];
                }

                if (key === 'availableColors') {
                    return { ...acc, [key]: value };
                }

                if (key === 'tags') {
                    return { ...acc, [key]: value };
                }

                if (Array.isArray(value)) {
                    value = value.map((o: any) => {
                        delete o['_id'];
                        return {
                            ...o,
                        };
                    });
                }

                if (key === 'downloads') {
                    return {
                        ...acc,
                        downloads: [
                            {
                                url: value?.url,
                                fileName: value?.fileName,
                            },
                        ],
                    };
                }

                return { ...acc, [key]: value };
            }, {});

            if (+updatedPayload.gallery) {
                updatedPayload.gallerySpatialRenderImages = [];

                if (+updatedPayload.gallery > 0) {
                    updatedPayload.gallerySpatialRenderImages.push({
                        'urls': [
                            {
                                'desktopPngUrl': 'string',
                                'desktopWebPUrl': 'string',
                                'mobilePngUrl': 'string',
                                'mobileWebPUrl': 'string',
                            },
                        ],
                    });
                    for (const key of payloadUrlName) {
                        const payloadKey = `galleryImage1--${key}`;
                        updatedPayload.gallerySpatialRenderImages[0].urls[0][key] = rawPayload[payloadKey][0].url;
                        delete updatedPayload[payloadKey];
                    }
                }

                if (+updatedPayload.gallery > 1) {
                    updatedPayload.gallerySpatialRenderImages.push({
                        'urls': [
                            {
                                'desktopPngUrl': 'string',
                                'desktopWebPUrl': 'string',
                                'mobilePngUrl': 'string',
                                'mobileWebPUrl': 'string',
                            },
                        ],
                    });
                    for (const key of payloadUrlName) {
                        const payloadKey = `galleryImage2--${key}`;
                        updatedPayload.gallerySpatialRenderImages[1].urls[0][key] = rawPayload[payloadKey][0].url;
                        delete updatedPayload[payloadKey];
                    }
                }

                if (+updatedPayload.gallery > 2) {
                    updatedPayload.gallerySpatialRenderImages.push({
                        'urls': [
                            {
                                'desktopPngUrl': 'string',
                                'desktopWebPUrl': 'string',
                                'mobilePngUrl': 'string',
                                'mobileWebPUrl': 'string',
                            },
                        ],
                    });
                    for (const key of payloadUrlName) {
                        const payloadKey = `galleryImage3--${key}`;
                        updatedPayload.gallerySpatialRenderImages[2].urls[0][key] = rawPayload[payloadKey][0].url;
                        delete updatedPayload[payloadKey];
                    }
                }
            }

            updatedPayload.gallery = !!updatedPayload.gallery;

            return { ...updatedPayload, color: 'null', availableColors: [] };
        }

        case CONTACT: {
            return {
                headOfficeAddress: rawPayload.headOfficeAddress,
                factoryAddress: rawPayload.factoryAddress,
                enquries: {
                    email: rawPayload.enEmail,
                    mobile: rawPayload.enMobile,
                },
                customerCare: {
                    email: rawPayload.email,
                    mobile: rawPayload.mobile,
                },
                showroomDetails: [
                    {
                        location: rawPayload.location,
                        address: rawPayload.address,
                        email: rawPayload.shEmail,
                        mobile: rawPayload.shMobile,
                        timing: rawPayload.timing,
                        images: [
                            {
                                desktopPngUrl: rawPayload.desktopPngUrl,
                                desktopWebPUrl: rawPayload.desktopWebPUrl,
                                mobilePngUrl: rawPayload.mobilePngUrl,
                                mobileWebPUrl: rawPayload.mobileWebPUrl,
                                imageInfo: rawPayload.imageInfo,
                            },
                        ],
                    },
                ],
            };
        }

        case CATALOGUE:
        case ABOUT: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                const payloadUrlName: any = {
                    1: 'desktopPngUrl',
                    2: 'desktopWebPUrl',
                    3: 'mobilePngUrl',
                    4: 'mobileWebPUrl',
                };
                if (key === 'images') {
                    acc['images'] = value.map((item: any, i: number) => {
                        const obj: any = {};
                        if (item['input' + i]) {
                            obj['imageInfo'] = item['input' + i];
                        }
                        [1, 2, 3, 4].forEach((num: any) => {
                            obj[payloadUrlName[num]] = item['image' + num][0]['response']['data'];
                        });
                        return obj;
                    });
                    return acc;
                }

                return { ...acc, [key]: value };
            }, {});
        }

        case SPACES: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                const payloadUrlName: any = {
                    1: 'desktopPngUrl',
                    2: 'desktopWebPUrl',
                    3: 'mobilePngUrl',
                    4: 'mobileWebPUrl',
                };
                if (key === 'images') {
                    acc['images'] = value.map((item: any, i: number) => {
                        const obj: any = {};
                        if (item['input' + i]) {
                            obj['imageInfo'] = item['input' + i];
                        }
                        [1, 2, 3, 4].forEach((num: any) => {
                            obj[payloadUrlName[num]] = item['image' + num][0]['response']['data'];
                        });
                        return obj;
                    });
                    return acc;
                } else if (key === 'products') {
                    acc['products'] = value.map((id: any) => {
                        if (typeof id === 'string') {
                            return id;
                        } else {
                            return id.value;
                        }
                    });
                    return acc;
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case USERS: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (key === 'permissions') {
                    acc['permissions'] = value
                        .map((permission: any) => {
                            const arr = [];
                            if (permission['create']) {
                                arr.push('create');
                            }
                            if (permission['read']) {
                                arr.push('read');
                            }
                            if (permission['update']) {
                                arr.push('update');
                            }
                            if (permission['delete']) {
                                arr.push('delete');
                            }
                            if (arr.length) {
                                return {
                                    subject: permission['name'],
                                    actions: arr,
                                };
                            } else {
                                false;
                            }
                        })
                        .filter((Permission: any) => Permission);
                    return acc;
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case HEADER_INFO: {
            let NAME = '';
            const obj = Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (key === 'name') {
                    NAME = value;
                }
                if (
                    key === 'desktopPngUrl' ||
                    key === 'desktopWebPUrl' ||
                    key === 'mobilePngUrl' ||
                    key === 'mobileWebPUrl' ||
                    key === 'imageInfo' ||
                    key === 'desktopPngUrl2' ||
                    key === 'desktopWebPUrl2' ||
                    key === 'mobilePngUrl2' ||
                    key === 'mobileWebPUrl2'
                ) {
                    const heroImageArray = [
                        {
                            desktopPngUrl: rawPayload.desktopPngUrl,
                            desktopWebPUrl: rawPayload.desktopWebPUrl,
                            mobilePngUrl: rawPayload.mobilePngUrl,
                            mobileWebPUrl: rawPayload.mobileWebPUrl,
                            imageInfo: rawPayload.imageInfo,
                        },
                    ];

                    // Add second heroImage object only if any of the second set fields have values
                    if (
                        rawPayload.desktopPngUrl2 ||
                        rawPayload.desktopWebPUrl2 ||
                        rawPayload.mobilePngUrl2 ||
                        rawPayload.mobileWebPUrl2
                    ) {
                        heroImageArray.push({
                            desktopPngUrl: rawPayload.desktopPngUrl2,
                            desktopWebPUrl: rawPayload.desktopWebPUrl2,
                            mobilePngUrl: rawPayload.mobilePngUrl2,
                            mobileWebPUrl: rawPayload.mobileWebPUrl2,
                            imageInfo: '', // Second image doesn't have separate imageInfo
                        });
                    }

                    acc[`${acc.name}`] = {
                        ...acc[NAME],
                        heroImage: heroImageArray,
                    };
                    return acc;
                }
                if (key === 'description') {
                    acc[NAME] = {
                        ...acc[NAME],
                        description: value,
                    };
                    return acc;
                }
                delete acc['imageInfo'];
                return { ...acc, [key]: value };
            }, {});
            delete obj['name'];
            return obj;
        }

        case USERS_ENTITY: {
            return Object.entries(rawPayload).reduce(
                (acc: any, [key, value]: any) =>
                    // if (key === 'role') {
                    //     return { ...acc, [key]: { id: value } };
                    // }
                    ({ ...acc, [key]: value }),
                {},
            );
        }

        case COMMISSION_LIST_ENTITY: {
            const { charge, commissionType } = rawPayload;

            if (!isCreateMode) {
                return {
                    charge: Number(charge),
                    commissionType: commissionType,
                };
            } else {
                return {
                    ...rawPayload,
                };
            }
        }

        case THIRD_PARTY_CHARGES_ENTITY:
        case TOWING_CHARGES_ENTITY: {
            const { charge, chargeType } = rawPayload;

            const payload = {
                charge: Number(charge),
                chargeType: chargeType,
            };

            return {
                ...payload,
            };
        }

        case MODELS_ENTITY: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (key === 'make') {
                    return { ...acc, [key]: { id: value } };
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case CATEGORY_SUBCATEGORIES_ENTITY: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (key === 'category') {
                    return { ...acc, [key]: { id: value } };
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case APPLICATION_FORM_SERVICES: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (key === 'parameters') {
                    return { ...acc, [key]: value.map((id: string) => id) };
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case APPLICATION_FORM_PACKAGE_PLANS: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (key === 'features') {
                    return { ...acc, [key]: value.map((id: string) => id) };
                }
                if (key === 'documents') {
                    return { ...acc, [key]: value.map((id: string) => id) };
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case CONTACT_INFO: {
            return Object.entries(rawPayload).reduce(
                (acc: any, [key, value]: any) => {
                    if (key === 'facebook') {
                        // Assuming value is a string representing the social media link
                        const socialMediaLinks = {
                            ...acc.socialMediaLinks,
                            [key]: `${rawPayload.facebook}`,
                        };
                        return { ...acc, socialMediaLinks };
                    }
                    if (key === 'twitter') {
                        // Assuming value is a string representing the social media link
                        const socialMediaLinks = {
                            ...acc.socialMediaLinks,
                            [key]: `${rawPayload.twitter}`,
                        };
                        return { ...acc, socialMediaLinks };
                    }
                    return { ...acc, [key]: value };
                },
                {
                    contactNumbers: ['string'],
                    email: 'string',
                    socialMediaLinks: {},
                },
            );
        }

        case GARAGE_COMMISSION_TYPE: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (key === 'garageName') {
                    return { ...acc, ['garage']: { id: value } };
                }
                if (key === 'commission') {
                    return { ...acc, ['commission']: { id: value } };
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case APPLICATION_FORM_QUESTIONS: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (key === 'service') {
                    return { ...acc, [key]: { id: value } };
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case SERVICE_PROCESS_DETAILS: {
            const { description, sequence, heading, service } = rawPayload;
            const payload = {
                heading: heading,
                description: description,
                sequence: sequence,
            };
            if (isCreateMode) {
                return {
                    ...payload,
                    service: { id: service },
                };
            } else {
                return {
                    ...payload,
                };
            }
        }

        case SERVICE_PROCESS_SUBTITLE: {
            const { description, sequence, heading, title } = rawPayload;
            const payload = {
                heading: heading,
                description: description,
                sequence: sequence,
            };
            if (isCreateMode) {
                return {
                    ...payload,
                    title: { id: title },
                };
            } else {
                return {
                    ...payload,
                };
            }
        }

        case SERVICE_PROCESS_STEPS: {
            const { description, sequence, service } = rawPayload;
            const payload = {
                description: description,
                sequence: sequence,
            };
            if (isCreateMode) {
                return {
                    ...payload,
                    service: { id: service },
                };
            } else {
                return {
                    ...payload,
                };
            }
        }

        case COUPONS_ENTITY: {
            const { name, description, couponCode, discount, validFrom, validTo, discountType, status, usesPerUser } =
                rawPayload;
            const formatDate = (date: any) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };

            // Convert validFrom and validTo to local dates and format
            const formattedValidFrom = formatDate(new Date(validFrom));
            const formattedValidTo = formatDate(new Date(validTo));

            const payload = {
                name: name,
                description: description,
                couponCode: couponCode,
                discount: discount,
                validFrom: formattedValidFrom,
                validTo: formattedValidTo,
                discountType: discountType,
                status: status,
                usesPerUser: Number(usesPerUser),
            };
            return {
                ...payload,
            };
        }

        case APPLICATION_FORM_PACKAGES: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (key === 'serviceAttributes') {
                    return { ...acc, [key]: value.map((id: string) => id) };
                }
                if (key === 'plans') {
                    return { ...acc, [key]: value.map((id: string) => id) };
                }
                if (key === 'service') {
                    return { ...acc, [key]: { id: value } };
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case ASSETS_ENTITY: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (key === 'locationType') {
                    return { ...acc, [key]: { id: value } };
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case LOCATIONS_ENTITY: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (key === 'locationType') {
                    return { ...acc, [key]: { id: value } };
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case SUBCATEGORIES_ENTITY: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (key === 'manager') {
                    return { ...acc, [key]: { id: value } };
                }
                if (key === 'category') {
                    return { ...acc, [key]: { id: value } };
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case CATEGORIES_ENTITY: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (key === 'asset') {
                    return { ...acc, [key]: { id: value } };
                }
                if (key === 'manager') {
                    return { ...acc, [key]: { id: value } };
                }

                return { ...acc, [key]: value };
            }, {});
        }

        case COMPLAINTS_ENTITY: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (key === 'defectType') {
                    return { ...acc, [key]: { id: value } };
                }
                return { ...acc, [key]: value };
            }, {});
        }

        case MANAGER_TECHNICIAN_ENTITY: {
            return Object.entries(rawPayload).reduce((acc: any, [key, value]: any) => {
                if (key === 'technicians') {
                    return { ...acc, [key]: value.map((id: string) => id) };
                }
                if (key === 'manager') {
                    return { ...acc, [key]: { id: value } };
                }
            }, {});
        }
    }

    const entityNamesArray = entityName?.split('/');
    const requiredEntityName = entityNamesArray[entityNamesArray.length - 1];

    switch (`/${requiredEntityName}`) {
        default:
            return rawPayload;
    }
};
